module.exports = __webpack_public_path__ + "img/8.9f46e7e9.jpg";